import { render, staticRenderFns } from "./SentTableMenu.vue?vue&type=template&id=a70f8d08&"
import script from "./SentTableMenu.vue?vue&type=script&lang=js&"
export * from "./SentTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports